'use es6';

export const validNumerical = ids => ids.map(Number).filter(id => !isNaN(id)).filter(id => id > 0);